"use client";

import type { PropsWithChildren } from "react";

import { GoogleOAuthProvider } from "@react-oauth/google";

import { Toaster } from "@/components/molecules/Toast";
import { useGoogleOneTapFusionAuth } from "~/hooks/useGoogleOneTapFusionAuth";

type GoogleOneTapProviderProps = PropsWithChildren<{
  clientId: string;
}>;

// The hook needs the GoogleOAuthProvider context, so it runs in a child of it.
const GoogleOneTap = () => {
  useGoogleOneTapFusionAuth();

  // TODO: the design-system Toaster isn't mounted globally, so One Tap error
  // toasts need their own. Pages that mount a Toaster (listing, vendor edit,
  // ContactSheet) will show these toasts twice until that's consolidated.
  return <Toaster />;
};

/**
 * Loads Google Identity Services and shows the One Tap sign-in prompt
 * when the site initializes.
 */
export const GoogleOneTapProvider = ({
  children,
  clientId,
}: GoogleOneTapProviderProps) => (
  <GoogleOAuthProvider clientId={clientId}>
    <GoogleOneTap />
    {children}
  </GoogleOAuthProvider>
);
